import React from "react";
import { motion } from "framer-motion";
import { useApp } from "@/context/AppContext";
import { ArrowUpRight, ArrowDownLeft, Plus, QrCode } from "lucide-react";

export default function QuickActions({ onSend, onRequest, onAdd, onScan }) {
  const { t } = useApp();

  const actions = [
    { key: "send", testid: "action-send-money", icon: ArrowUpRight, label: t.send, onClick: onSend },
    { key: "request", testid: "action-request-money", icon: ArrowDownLeft, label: t.request, onClick: onRequest },
    { key: "add", testid: "action-add-money-grid", icon: Plus, label: t.add, onClick: onAdd },
    { key: "scan", testid: "action-scan-qr", icon: QrCode, label: t.scan, onClick: onScan },
  ];

  return (
    <div className="grid grid-cols-4 gap-3 my-6">
      {actions.map((a, i) => (
        <motion.button
          key={a.key}
          data-testid={a.testid}
          onClick={a.onClick}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 + i * 0.06 }}
          className="flex flex-col items-center gap-2 group"
        >
          <span className="w-14 h-14 rounded-2xl bg-card border border-border grid place-items-center shadow-sm group-hover:border-primary/40 group-hover:bg-primary/5 group-active:scale-90 transition-all">
            <a.icon className="w-6 h-6 text-primary" />
          </span>
          <span className="text-xs font-semibold text-foreground/80">{a.label}</span>
        </motion.button>
      ))}
    </div>
  );
}
